export default "__VITE_PUBLIC_ASSET__233c07c7__"